<template>
    <div class="slim bookable-block container">
        <h3 class="block-title text-center" v-if="this.content.meta.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <div v-if="aliveBookables.length" class="row px-2 justify-content-center">
            <div v-for="bookable in aliveBookables" :key="bookable.id" class="col-12 col-sm-6 col-md-4">
                <div class="bookable-item" @click="selectService(bookable)">
                    <div class="bookable-image-container">
                        <img class="bookable-image" v-if="bookable.contentUnit.file_name" :src="context.storageEndpoint + bookable.contentUnit.file_name" />
                    </div>

                    <div class="bookable-info mt-2">
                        <div class="bookable-title">
                            {{ bookable.name }}
                        </div>
                        <p class="bookable-content" v-html="getFormattedContent(bookable.content)"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventClickBookableItem } from '../../bu/models/GA4';
    import api from '../../mixins/api';
    import autoLink from '../../mixins/autolink';
    export default {
        props: ['block', 'providerId', 'context'],
        mixins: [autoLink, api],

        mounted() {
            this.getServices((response, error) => {
                if (response?.data) {
                    response.data.forEach(service => {
                        this.servicesMap[service.id] = service;
                    })
                    this.isFetched = true;
                }
            });
        },
        data: function() {
            if (typeof this.block.content === 'string') {
                this.block.content = JSON.parse(this.block.content);
            }
            if (!this.block.content.bookables) {
                this.block.content.bookables = [];
            }

            return {
                id: this.block.id,
                content: this.block.content,
                informationBlock: this.block.information_block,
                bookables: this.block.content.bookables,
                isFetched: false,
                servicesMap: {},
            };
        },
        methods: {
            selectService(bookable) {
                this.$emit('bookableClick', bookable);
                this.trackClickBookableItem(bookable);
            },
            getFormattedContent(content) {
                return content.nl2brIfNotHTML();
            },
            trackClickBookableItem(bookable) {
                window.tracker.track(() => new EventClickBookableItem(bookable));
            }
        },
        computed: {
            aliveBookables() {
                if (this.isFetched) {
                    return this.bookables.filter(bookable => {
                        const service = this.servicesMap[bookable.service_id];
                        if (service?.archived_at) {
                            return false;
                        }
                        if (service?.is_disabled) {
                            return service.is_preview;
                        }
                        return true;
                    });
                } else {
                    return [];
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .bookable-block {
        padding-bottom: 2.5em !important;
    }

    .bookable-image-empty {
        border: none;
        background: transparent;
        cursor: pointer;

        i {
            color: #aaa;
        }
    }

    .bookable-item {
        height: calc(100% - 16px);
        position: relative;
        align-items: center;
        margin-top: 1.2em;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }

    .bookable-item:hover .handle {
        display: block;
    }

    .handle {
        display: none;
    }

    .bookable-info {
        padding: 0 12px;
        position: relative;
    }
    .delete-button {
        display: none;
        padding: 0;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        line-height: 20px;
        color: white;
        position: absolute;
        border-color: transparent;
        top: -10px;
        right: -10px;

        i {
            position: relative;
            top: -2px;
        }
    }

    .bookable-item:hover .delete-button {
        display: block;
    }

    .bookable-image-container {
        width: 100%;
        aspect-ratio: 16/9;
        display: flex;
        align-items: center;
        justify-content: center;
        /* background: #ddd; */
        border: 1px solid transparent;
        border-radius: 8px;
        overflow: hidden;
        &>div, &>div>div {
            width: 100%;
            aspect-ratio: 16 / 9;
        }
         &>div>div {
            display: flex;
            align-items: center;
            justify-content: center;
         }

        .bookable-image {
            width: 100%;
        }
    }

    .bookable-title {
        font-size: 16px;
        color: #888;
        text-align: left;
        margin-bottom: 8px;;
        word-break: normal;
        overflow-wrap: break-word;
    }

    .bookable-content {
        font-size: 12px;
        text-align: left;
        color: #aaa;
        margin-top: 0;
        margin-bottom: 0.5em;
        word-break: normal;
        overflow-wrap: break-word;
    }

    /deep/ .bookable-content .wrapper {
        text-align: left;
    }
    /deep/ .bookable-content p {
        margin: 0;
    }
</style>